// extracted by mini-css-extract-plugin
export default {"patternInput":"PatternSection_patternInput__ryhiF"};